module.exports = __webpack_public_path__ + "assets/img/shrink_1.37d0f6e6.svg";